// Libraries
import { MutationTuple, useMutation } from "@apollo/client";
// API
import { ASSIGN_ANIMALS_TO_GROUP } from "api/MyLivestock/Groups/mutations";
import { AssignAnimalsToGroup, AssignAnimalsToGroupVariables } from "api/MyLivestock/Groups/types/AssignAnimalsToGroup";

export const useAssignAnimalsToGroup = (): MutationTuple<AssignAnimalsToGroup, AssignAnimalsToGroupVariables> =>
  useMutation<AssignAnimalsToGroup, AssignAnimalsToGroupVariables>(ASSIGN_ANIMALS_TO_GROUP);
